import BreathingTranslationsResponse from '../../../../../Spirit/Admin/Interfaces/Models/BreathingService/BreathingTranslationsResponse';

export default class BreathingUpdateRequest  {
	Id?: number = null;
	IsPaid: boolean = false;
	BackgroundFileId: string = '';
	RepeatCount: number = 0;
	BreathHoldingFirst: number = 0;
	BreathHoldingSecond: number = 0;
	Exhalation: number = 0;
	Inhalation: number = 0;
	Translations: Array<BreathingTranslationsResponse> = null;
	constructor(obj?: Partial<BreathingUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
